import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import CycleDetails from "SnP_v2/routes/CycleDetails";
import CycleDetailsV2 from "SnP/routes/CycleDetails";
import NotificationSettings from "Teacher/routes/NotificationSettings";
import ProjectGroupTypes from "Teacher/routes/ProjectGroupTypes";
export default store => ({
  path: "visitors",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "standards-and-practices" */ "./components"
        ),
        import(
          /* webpackChunkName: "standards-and-practices" */ "SnP_v2/modules/SnPModule"
        ),
        import(
          /* webpackChunkName: "standards-and-practices" */ "Platform/routes/VisitorHome/modules/VisitorHomeModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const visitorHomeReducer = importedModule2.default;
        injectReducer(store, {
          key: "snpV2",
          reducer,
        });
        injectReducer(store, {
          key: "visitorHome",
          reducer: visitorHomeReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    CycleDetails(store),
    CycleDetailsV2(store),
    NotificationSettings(store),
    ProjectGroupTypes(store),
  ],
});
